import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-modal-confirmacao',
  templateUrl: './modal-confirmacao.component.html',
  styleUrls: ['./modal-confirmacao.component.scss']
})
export class ModalConfirmacaoComponent implements OnInit {

  @Input() titulo: string;
  @Input() mensagem: string;
  @Input() btnPrimarioTxt: string = 'OK';
  @Input() btnSecundarioTxt: string = 'CANCELAR';



  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit() {
  }

  onFechar() {
    this.bsModalRef.hide();
  }

  onConfirmar() {
    this.bsModalRef.hide();
  }

}
